import { Navbar } from "@/components/home/Navbar";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Services } from "@/components/home/Services";
import { Manifesto } from "@/components/home/Manifesto";
import { About } from "@/components/home/About";
import { Testimonials } from "@/components/home/Testimonials";
import { EmiCalculator } from "@/components/home/EmiCalculator";
import { Contact } from "@/components/home/Contact";
import { Footer } from "@/components/home/Footer";

export default function Home() {
  return (
    <div className="relative">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <About />
        <Testimonials />
        <EmiCalculator />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
